import { HttpService, MessageService, ModalService } from '@philips-emr/tws-core/lib/services';
import { ResponseBodyMapperType } from '@philips-emr/tws-core/lib/services/http-service';
import { ModalProps } from '@philips-emr/tws-core/lib/services/modal-service';

import { Endpoint } from '../constants';

import { ToastServiceProviderAccreditation } from './toast-service';

interface Report {
  cdClassifRelat: string;
  cdRelatorio: string;
  title: string;
  nrSequence: string;
  cdGrupo: string;
  type: string;
  reportPath: string;
}

function getReportsByGroup(cdGroup: string, endpoint: string = '', requestParams: {} = {}): Promise<Report[]> {
  const params = { ...requestParams, cdGroup };

  const requestEndpoint = endpoint !== '' ? endpoint : Endpoint.GET.REPORT_BY_GROUP;

  return HttpService.get(requestEndpoint, params)
    .then(resp => resp.body as Report[]);
}

function openReportModal(src: string): void {
  const modalWithFragment: ModalProps = {
    closeable: true,
    fragment: 'pdf-viewer',
    contextData: { src },
  };
  ModalService.openFullscreen(modalWithFragment);
}

function openReportsListModal(endpoint: string, requestParams: {}, cdGroup: string, reports: Report[]): void {
  const modalWithFragment: ModalProps = {
    closeable: true,
    fragment: 'hpms-reports-modal',
    title: 'pa.reports',
    contextData: { cdGroup, reports, endpoint, requestParams },
    className: 'modal-reports',
    id: 'modal-report-list',
  };
  ModalService.openDefault(modalWithFragment);
}

function openInNewWindow(url: string): void {
  const win = window.open(url, '_blank');
  win && win.focus();
}

async function generateReport(endpoint: string, requestParams: {}, cdGroup: string, report?: Report, reportParams?: {}): Promise<void> {
  const reports = await getReportsByGroup(cdGroup);
  if (reports.length > 1 && !report) {
    openReportsListModal(endpoint, requestParams, cdGroup, reports);
    return;
  }

  if (reports.length == 1 && !report) {
    report = reports[0];
  }

  const body = {
    group: report?.cdGrupo,
    code: report?.cdRelatorio,
    type: report?.cdClassifRelat,
    ...reportParams,
  };

  const responseBodyMapperType: ResponseBodyMapperType = ResponseBodyMapperType.BLOB;
  document.body.style.cursor = 'wait';
  return HttpService.post(endpoint, requestParams, { body, responseBodyMapperType })
    .then(response => {
      const { type } = response.body as Report;
      const file = new Blob([response.body as Blob], { type: type });

      if (type == 'application/json') {
        file.text().then((resp) => {
          openReportModal(resp);
        }).catch(() => {
          ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request'));
        });
      } else {
        const url = URL.createObjectURL(file);
        openInNewWindow(url);
      }
    })
    .catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')))
    .finally(() => ModalService.close('modal-report-list'));
}

export {
  Report,
  getReportsByGroup,
  openReportModal,
  openReportsListModal,
  openInNewWindow,
  generateReport,
};

